












import { Component, Vue } from 'vue-property-decorator'
import { StepKeys } from '../../variables/ACF_Key'
import Title from '../../components/Title.vue'
import Formulaire from '../../components/Formulaire.vue'
import Wizard from '../Wizard.vue'
import Retour from '../../components/Retour.vue'
@Component({
  components: {
    Title,
    Formulaire,
    Wizard,
    Retour
  }
})
export default class Form extends Vue {
    // Datas de la vue :
    public ready = false
    public form !: string
    // Data a transmettre au titre :
    public titleMain !: string
    // Vue actuelle
    public step = 7
    //* ************ <!>IMPORTANT<!> -> Object pour enregistrer le JSON récupéré par AXIOS
    public responseACF!: Record<string, string>

    sortACFForThisView (): void{
      // Appel la class permettant de lire le trie du JSON (API WP)
      const formInfo = new StepKeys(this.responseACF)
      if (formInfo) {
        // Ajouter la clef ACF des items de la vue
        /***
         * INFO ci-dessous à modifier selon le projet :
         */
        /***
         * Titre de la vue :
         */
        this.titleMain = formInfo.getSimpleValue('form_title')
        /***
         * Form CF7 de la vue :
         */
        this.form = formInfo.getSimpleValue('form_item')

        this.ready = true
      }
    }

    /***
     * VUE STATE =>
     */
    mounted (): void {
      this.responseACF = this.$store.getters.getValueOfACF
      // Plus besoin de requetter l'api à partir de cette vue car la valeur des ACFs sont stockées dans le vuex
      if (this.responseACF) {
        this.sortACFForThisView()
      }
    }

}
